module.exports = __webpack_public_path__ + "img/screenr-full.d71d564b.png";